export default __webpack_public_path__ + "static/media/ic_romania.6e23adc9.svg";